<template>
  <div class="rightNav">
    <ul class="tab-nav">
      <!-- <li>
        <div class="nav_one" @click="goToVideo">
          <span class="title">VIDEO</span>
          <i v-if="item.list.length" id="right-btn" class="el-icon-arrow-down"></i>
        </div>
      </li> -->
      <li v-for="(item, index) in navList" :key="index">
        <div class="nav" @click="openNav(index, item.children.length, item.name)">
          <span class="title">{{ item.name }}</span>
          <i v-if="item.children.length" id="right-btn" class="el-icon-arrow-down"></i>
        </div>
        <ul class="nav-n-box">
          <li
            class="nav-n"
            v-for="(n, i) in item.children"
            :key="i"
            @click="topath1(n, item.name, i)"
          >
            <!-- <span style="font-size: 30px">·</span> -->
            <div class="nav-n-dot"></div>
            <span class="nav-n-title">{{ n.name }}</span>
          </li>
        </ul>
        <!-- <div class="nav_one" @click="goToOpinion" v-if="index == 2 ">
          <span class="title">Opinion</span>
        </div> -->
        <!-- <div class="nav_one" @click="goToFeature" v-if="index == 3 ">
          <span class="title">FEATURE</span>
        </div> -->
      </li>
      <!-- <li v-if="navList.length <= 3">
        <div class="nav_one" @click="goToOpinion">
          <span class="title">Opinion</span>
        </div>
        <div class="nav_one" @click="goToFeature">
          <span class="title">FEATURE</span>
        </div>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { getNavList } from "@/network/home.js";
export default {
  name: "Collapse",
  data() {
    return {
      navList: [
        // {
        //   title: "Video",
        //   name: "/video",
        //   children: [],
        // },
        {
          title: "NEWS",
          name: "NEWS",
          children: [
            {
              title: "METRO",
              name: "METRO",
            },
            {
              title: "CHINA",
              name: "CHINA",
            },
            {
              title: "WORLD",
              name: "WORLD",
            },
            {
              title: "BIZ",
              name: "BIZ",
            },
            // {
            //   title: "World",
            //   name: "/news",
            // },
          ],
        },
        {
          title: "COLUMN",
          name: "COLUMN",
          children: [],
        },
        {
          title: "OPINION",
          name: "OPINION",
          children: [],
        },
        {
          title: "DOCUMENTARY",
          name: "DOCUMENTARY",
          children: [],
        },
        {
          title: "VIDEO",
          name: "VIDEO",
          children: [],
        },
        {
          title: "LIVE",
          name: "LIVE",
          children: [],
        },
        // {
        //   title: "Biz",
        //   name: "News",
        //   children: [
        //     {
        //       title: "Company",
        //       name: "/news",
        //     },
        //     {
        //       title: "Money Talks",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Global",
        //       name: "BusinessIntroduction",
        //     },
        //   ],
        // },
        // {
        //   title: "Culture",
        //   name: "AboutUs",
        //   children: [
        //     {
        //       title: "Art",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Backtage Peek",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Education",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Entertainment",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Fashion",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Food",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "24 SolarTerms",
        //       name: "BusinessIntroduction",
        //     },
        //   ],
        // },
        // {
        //   title: "Opinion",
        //   name: "AboutUs",
        //   children: [],
        // },
        // {
        //   title: "Feature",
        //   name: "/feature",
        //   children: [],
        // },
        // {
        //   title: "More Topic",
        //   name: "AboutUs",
        //   children: [
        //     {
        //       title: "More",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Topic",
        //       name: "BusinessIntroduction",
        //     },
        //     {
        //       title: "Culture",
        //       name: "BusinessIntroduction",
        //     },
        //   ],
        // },
      ],
    };
  },
  mounted() {
    // this.getListFn();
  },
  methods: {
    //获取菜单
    getListFn() {
      getNavList().then((res) => {
        this.navList = res.data;
        console.log(this.navList);
      });
    },
    goToVideo() {
      // console.log(this.$router.currentRoute.path);
      if (this.$router.currentRoute.path == "/video") {
        return;
      } else {
        this.$router.push("/video");
      }
    },
    goToFeature() {
      if (this.$router.currentRoute.path == "/feature") {
        return;
      } else {
        this.$router.push("/feature");
      }
    },
    goToOpinion() {
      // this.$router.push('/opinion');
    },
    topath1(item, name, index) {
      this.$router
        .push({
          path: "/News",
          query: {
            pT: name,
            cT: item.name,
          },
        })
        .catch((err) => {
          err;
        });
    },
    topath(item, index) {
      // console.log(item)
    },
    openNav(index, num, name = null) {
      if (num <= 0) {
        // 没有children，直接点击跳转
        switch (name) {
          case "COLUMN":
            this.goToFeature()
            break;
          case "OPINION":
            this.$router
              .push({
                path: "/News",
                query: {
                  pT: 'MORE TOPICS',
                  cT: 'OPINION',
                },
              })
              .catch((err) => {
                err;
              });
            break;
          case "DOCUMENTARY":
            this.$router
              .push({
                path: "/News",
                query: {
                  pT: 'FEATURE',
                  cT: 'DOCUMENTARIES',
                },
              })
              .catch((err) => {
                err;
              });
            break;
          case "VIDEO":
            this.goToVideo()
            break;
          case "LIVE":
            this.$router.push({
              path: '/live'
            })
            break;
        }
        return;
      }
      if (name == "Opinion") {
        this.$router
          .push({
            path: "/News",
            query: {
              cT: name,
            },
          })
          .catch((err) => {
            err;
          });
      }
      let _this = this;
      let nav = document.querySelectorAll(".nav"); //获取父级菜单栏，以便添加选中样式
      let items = document.querySelectorAll(".nav-n-box"); //获取容纳子级菜单栏的容器，以便动态设置高度，实现下拉效果

      //-----------------可注释部分开始------注释后则不是手风琴效果------------------
      // 遍历菜单栏，移除所有选中后的样式   添加此段可实现手风琴效果，注释则实现多展示效果
      for (let i = 0; i < nav.length; i++) {
        // nav[index].classList.contains("nav-n-box-active") 判断标签内是否含有该class属性，以布尔值类型返回
        console.log(items[i].style.display, "display");
        if (
          items[i].style.display == "none" ||
          items[i].style.display == "" ||
          // items[i].style.height == "" ||
          // items[i].style.height == "0rem" ||
          nav[index].classList.contains("nav-n-box-active")
        ) {
          console.log("11111");
          let height = items[index].style.display;
          items[index].style.display = height;
          // items[index].style.display ='none'
          // let height = items[index].style.height;
          // items[index].style.height = height;
        } else {
          // items[i].style.height = "0px";
          console.log("2222");
          items[i].style.display = "none";
        }
        nav[i].classList.remove("nav-n-box-active");
      }
      //-----------------可注释部分结束------------------------

      //根据子菜单栏的高度判断，是否展开菜单栏，若有进行遍历操作，那么每次点击某个菜单栏的时候 height 都为 0
      console.log(items[index].style.display, "display222222");

      if (
        items[index].style.display == "" ||
        items[index].style.display == "none"
        // items[index].style.height == "" ||
        // items[index].style.height == "0px"
      ) {
        console.log("333333");
        console.log(nav.length);

        for (var i = 0; i < nav.length; i++) {
          nav[i].style.borderBottom = "1px solid rgba(34, 12, 87, .2)";
        }
        nav[index].style.borderBottom = "none";
        //num 为子菜单栏的个数，根据子菜单栏确定容器的高度
        // if (num % 2 == 0) {
        //   items[index].style.height = (num * 30) / 2 + "px";
        // } else {
        //   items[index].style.height = (num * 40) / 2 + "px";
        // }
        // if(num == 1){
        //   items[index].style.height = 30 + "px";
        // }
        items[index].style.display = "block";
        //添加右箭头旋转样式
        nav[index].classList.add("nav-n-box-active");
      } else {
        console.log("5444444");
        // items[index].style.height = "0px";
        items[index].style.display = "none";

        nav[index].style.borderBottom = "1px solid rgba(34, 12, 87, .2)";
        //移除右箭头旋转样式
        nav[index].classList.remove("nav-n-box-active");
      }
      //------------------------------------------
    },
  },
};
</script>

<style lang="less" scoped>
.rightNav {
  height: calc(100% - 100px);
  width: 100%;
  z-index: 100;
  ul {
    margin-bottom: 5px;
  }
  .tab-nav {
    margin: 10px 24px;
    li {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      cursor: pointer;
      user-select: none;
      .nav,
      .nav_one {
        padding: 24px 6px 24px 0px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid rgba(34, 12, 87, 0.2);
        .title {
          font-size: 16px;
          font-weight: bolder;
        }
        i {
          transition: 0.3s;
          color: #867ead;
          font-size: 16px;
          font-weight: bold;
        }
        span {
          display: inline-block;
          text-align: left;
          font-size: 60px;
          font-family: FranklinGothic-Demi, FranklinGothic;
          font-weight: normal;
          color: #220c57;
          margin-left: 5px;
        }
      }
      .nav-n-box {
        transition: 0.3s;
        width: 100%;
        // height: 0;
        display: none;
        overflow: hidden;
        border-bottom: 1px solid rgba(34, 12, 87, 0.2);
        .nav-n {
          width: 45% !important;
          font-size: 14px;
          font-family: OpenSans;
          color: #220c57;
          display: flex;
          align-items: center;
          // height: 28px;
          text-align: left;
          line-height: 22px;
          transition: 0.3s;
          font-family: Open Sans;
          // padding-left: 8px;
          font-size: 13px;
          line-height: 20px;
          // padding: 7px 0;
          float: left;
          margin-bottom: 30px;
          .nav-n-title {
            padding-left: 0.13rem;
            flex: 1;
          }
          .nav-n-dot {
            width: 4px;
            height: 4px;
            background: #867ead;
            border-radius: 50%;
          }
          &:hover {
            color: #220c57;
            font-family: FranklinGothic-Demi, FranklinGothic;
            font-weight: normal;
            .nav-n-dot {
              background: #220c57;
            }
          }
          // &:visited {
          //   color: #3daeaf;
          // }
        }
      }
    }
  }
}
//点击后右箭头的反转效果
.nav-n-box-active {
  #right-btn {
    transform: rotate(180deg) !important;
  }
}
</style>
